// src/App.js
import React from 'react';
import useMeta from '../../hooks/useMeta';

import Navbar from '../../CommonComponent/Navbar/Navbar'; // Importing the Navbar component
import Footer from '../../CommonComponent/Footer/footer';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';


//page component

import EEcontent from './PageComponent/EEcontent'

function EnergyEfficiency() {

    useMeta({
        title: 'Energy Efficiency | Callistus Blinds',
        description: 'Discover premium window treatments at Callistus Blinds. Explore our extensive range of stylish blinds and shades to enhance your home’s aesthetic and comfort.',
        canonical: 'https://callistusblinds.com/energy-efficiency/',
        og: {
            locale: 'en_US',
            type: 'article',
            title: 'Energy Efficiency | Callistus Blinds',
            description:
                'Callistus window blinds help conserve energy in the following important ways.',
            url: 'https://callistusblinds.com/energy-efficiency/',
            site_name: 'Callistus Blinds',
        },
    });

    return (
        <div>
            <Navbar />
            <NotificationBar />
            <EEcontent />
            <Footer />
        </div>
    );
}

export default EnergyEfficiency;
